import { createSelector } from 'reselect'
import {
    isCurrentMediaTypeImage,
    isCurrentMediaViewable,
    isCurrentMediaSourceLoadedInDefaultFrame,
    getCurrentMediaTitle,
    isCurrentMediaSourceLoadedInPreviewFrame,
} from '../currentMedia/selectors'
import {isDownloadEnabled, isSocialEnabled, isIIIFEnabled} from "../app/selectors"
import { A4_RATIO } from '../../helpers/print'
import { Rectangle } from '../../helpers/math'

export const isPrintPreviewOpened = state => state.print.isOpened === true

export const isPrintPreviewDisabled = state => {
    return ! (
        isCurrentMediaTypeImage(state)
        && isCurrentMediaViewable(state)
        &&
        (
            isCurrentMediaSourceLoadedInDefaultFrame(state)
            || isCurrentMediaSourceLoadedInPreviewFrame(state)
        )
    )
}

export const isSocialDisplayed = state => isSocialEnabled(state)

export const isIIIDisplayed = state => isIIIFEnabled(state)

export const isDownloadDisplayed = state => isDownloadEnabled(state)

export const getPrintOrientation = state => state.print.orientation

export const getTitleCharacterLimit = createSelector(
    getPrintOrientation,
    printOrientation => printOrientation === 'portrait' ? 65 : 105
)

export const isLandscapeOrientation = createSelector(
    getPrintOrientation,
    printOrientation => printOrientation === 'landscape'
)

export const getPrintOrientationAngle = createSelector(
    isLandscapeOrientation,
    isLandscapeOrientation => isLandscapeOrientation ? 90 : 0
)

export const getPreviewSheet  = createSelector(
    getPrintOrientationAngle,
    (state, frame) => frame,
    (printOrientationAngle, frame) => (
        new Rectangle(
            Math.round(frame.height * A4_RATIO),
            frame.height
        ).rotate(printOrientationAngle)
    )
)

export const getPrintMediaTitle = createSelector(
    getCurrentMediaTitle,
    getTitleCharacterLimit,
    (currentMediaTitle, characterLimit) => {

        let title = []
        title = truncateTitle(title, currentMediaTitle, 'recordTitle', 60, characterLimit)
        title = truncateTitle(title, currentMediaTitle, 'referenceCode', 20, characterLimit)
        title = truncateTitle(title, currentMediaTitle, 'appName', 20, characterLimit)

        return title.join(' - ')
    }
)

function truncateTitle(title, currentMediaTitle, titlePart, pourcent, nbCharMax)
{
    if(currentMediaTitle[titlePart] && currentMediaTitle[titlePart].trim() !== '')
    {
        const limit = nbCharMax * pourcent / 100
        let ellips = ''
        if(currentMediaTitle[titlePart].length > limit)
        {
            ellips = '...'
        }

        title.push(`${currentMediaTitle[titlePart].slice(0, limit)}${ellips}`)
    }

    return title
}
